import React from "react";
import { Navigation, MapPinned } from "lucide-react";
import { googleRouteUrl, appleRouteUrl } from "@/lib/api";

export default function OpenInMaps({ home, stores, compact = false }) {
  if (!stores?.length) return null;
  const first = stores[0];
  const base = "flex-1 inline-flex items-center justify-center gap-2 rounded-full font-bold transition-transform duration-150 hover:scale-[1.02] active:scale-[0.98]";
  const size = compact ? "h-9 px-3 text-xs" : "h-11 px-4 text-sm";
  return (
    <div>
    <div className="flex gap-2" data-testid="open-in-maps">
      <a href={googleRouteUrl(home, stores)} target="_blank" rel="noreferrer" data-testid="open-google-maps-button"
        className={`${base} ${size} bg-pp-forest text-white`}>
        <Navigation className="h-4 w-4" /> Google Maps
      </a>
      <a href={appleRouteUrl(home, first)} target="_blank" rel="noreferrer" data-testid="open-apple-maps-button"
        className={`${base} ${size} bg-white border border-pp-border text-pp-text`}>
        <MapPinned className="h-4 w-4" /> Apple Maps
      </a>
    </div>
    {stores.length > 1 && !compact && <p className="mt-1.5 text-[11px] text-pp-muted">Google Maps opens the full route. Apple Maps opens one stop at a time, starting with your first store.</p>}
    </div>
  );
}
